module.exports = __webpack_public_path__ + "static/media/open-drawer.5c5313eb.svg";